import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { FormLabel } from '../../content/FormLabel/FormLabel';

const RawToggleWrapper = styled.div``;

export type RawToggleValueType = boolean | null;

export type RawToggleProps = {
  disabled: boolean;
  id?: string;
  name: string;
  onChange?: (value: boolean) => Promise<unknown> | void;
  value: RawToggleValueType;
  variation?: 'default' | 'minimal';
};

export const RawToggle = ({
  disabled,
  id,
  name,
  onChange,
  value,
  variation,
}: RawToggleProps) => {
  const minimal = variation === 'minimal';
  const handleOnClick = () => {
    if (!disabled) {
      void onChange?.(!value);
    }
  };
  return (
    <RawToggleWrapper
      className={AttrsHelper.formatClassname(
        'toggle',
        disabled && 'disabled',
        minimal && 'minimal',
        value && 'active'
      )}
      id={id}
      tabIndex={0}
      data-test={name}
      onClick={handleOnClick}
    >
      <span
        className={AttrsHelper.formatClassname(
          'toggle-slider',
          value && `toggle-transition-right${minimal ? '-minimal' : ''}`,
          value && 'active'
        )}
      />
      <span
        className={AttrsHelper.formatClassname(
          'toggle-option',
          !value && 'active'
        )}
        data-test={`${name}-no`}
      >
        {!minimal && !value ? (
          <FormLabel name="toggle-label" className="toggle-label">
            No
          </FormLabel>
        ) : null}
      </span>
      <span
        className={AttrsHelper.formatClassname(
          'toggle-option',
          value && 'active'
        )}
        data-test={`${name}-yes`}
      >
        {value && !minimal ? (
          <FormLabel name="toggle-label" className="toggle-label">
            Yes
          </FormLabel>
        ) : null}
      </span>
    </RawToggleWrapper>
  );
};
